import { gsap } from 'gsap/dist/gsap';
const newsLanding = () => {
  $('.all-news-padding')
    .on('mouseenter', function () {
      const tlBlocks = new gsap.timeline();
      tlBlocks
        .to($(this).find('.all-news-entry-h'), 0.3, {
          y: '-60',
          ease: 'power4.out',
        })
        .to(
          $(this).find('.all-news-entry-b'),
          0.3,
          {
            opacity: '1',
            y: '-50',
            height: '40px',
            ease: 'power4.out',
          },
          '-=.3'
        )
        .to(
          $(this).find('.all-news-cat'),
          0.3,
          {
            opacity: '0',
            ease: 'power4.out',
          },
          '-=.3'
        )
        .to(
          $(this).find('.all-news-bg'),
          0.3,
          {
            border: '1px solid #aa9767',
            ease: 'power4.out',
          },
          '-=.3'
        );
      tlBlocks.play();
    })
    .on('mouseleave', function () {
      const tlBlocksR = new gsap.timeline();
      tlBlocksR
        .to($(this).find('.all-news-entry-h'), 0.3, {
          y: '0',
          ease: 'power4.out',
        })
        .to(
          $(this).find('.all-news-entry-b'),
          0.3,
          {
            opacity: '0',
            y: '0',
            height: '0px',
            ease: 'power4.out',
          },
          '-=.3'
        )
        .to(
          $(this).find('.all-news-cat'),
          0.3,
          {
            opacity: '1',
            ease: 'power4.out',
          },
          '-=.3'
        )
        .to(
          $(this).find('.all-news-bg'),
          0.3,
          {
            border: '1px solid transparent',
            ease: 'power4.out',
          },
          '-=.3'
        );
      tlBlocksR.play();
    });
};

export default newsLanding;
